import React from 'react'
import { withStyles, createStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import MenuIcon from '@material-ui/icons/Menu'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'
import Dialog from '@material-ui/core/Dialog'
import { Link } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Typography from 'components/shared/Typography'
import Slide from '@material-ui/core/Slide'

const Transition = props => <Slide direction="left" {...props} />

const styles = theme =>
  createStyles({
    paper: {
      height: '100%',
      maxHeight: 'none',
      margin: '0 0 0 50px',
      backgroundColor: theme.palette.primary.main,
    },
  })

interface IProps {
  currentPath: string
  logOut: () => void
  paths: any
  classes?: any
}

interface IState {
  open: boolean
}

export class MobileMenu extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      open: false,
    }
  }

  handleClickOpen = () => {
    this.setState({
      open: true,
    })
  }

  handleClose = () => {
    this.setState({
      open: false,
    })
  }

  render() {
    const { paths, classes, logOut } = this.props
    return (
      <div>
        <IconButton color="primary" aria-label="Menu" onClick={this.handleClickOpen}>
          <MenuIcon />
        </IconButton>
        <Dialog
          fullWidth
          open={this.state.open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
          classes={{ paper: classes.paper }}
        >
          <Box pl={4}>
            <Grid container direction="column">
              <Grid container item justify="flex-end">
                <IconButton color="secondary" onClick={this.handleClose} aria-label="Close">
                  <CloseIcon />
                </IconButton>
              </Grid>
              {paths.map(({ link, name }) => (
                <Grid item key={link} onClick={this.handleClose}>
                  <Link to={link}>
                    <Typography variant="h3" color="textSecondary">
                      <Box my={1.5}>{name}</Box>
                    </Typography>
                  </Link>
                </Grid>
              ))}
              <Grid
                item
                onClick={() => {
                  logOut()
                  this.handleClose()
                }}
              >
                <Typography variant="h3" color="textSecondary">
                  <Box my={1.5}>Log out</Box>
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Dialog>
      </div>
    )
  }
}

export default withStyles(styles)(MobileMenu)
